import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@modules/material/material.module';
import { DateModule } from '@modules/date/date.module';
import { Ng2FittextModule } from 'ng2-fittext';

import { AutocompletePatientComponent } from '@components/admin/autocomplete-patient/autocomplete-patient.component';
import { AutocompleteVendorProductsComponent } from '@components/admin/autocomplete-vendor-products/autocomplete-vendor-products.component';
import { AutocompleteVendorsComponent } from '@components/admin/autocomplete-vendors/autocomplete-vendors.component';
import { OkCancelComponent } from '@components/admin/dialog/ok-cancel/ok-cancel.component';
import { SaveComponent } from '@components/admin/dialog/save/save.component';
import { UnsavedComponent } from '@components/admin/dialog/unsaved/unsaved.component';
import { LogoutComponent } from '@components/admin/dialog/logout/logout.component';
import { DeleteComponent } from '@components/admin/dialog/delete/delete.component';
import { GalleryComponent } from '@components/admin/dialog/gallery/gallery.component';
import { PatientDialogComponent } from '@components/admin/dialog/patient/patient-dialog.component';
import { ThumbnailDirective } from '@directives/thumbnail.directive';
import { HighlightDirective } from '@directives/highlight.directive';
import { ClickFieldDirective } from '@directives/click-field.directive';
import { NewlinePipe } from '@pipes/newline.pipe';
import { PhonePipe } from '@pipes/phone.pipe';
import { DisplayInvoicePipe } from '@pipes/display-invoice.pipe';
import { StoreNamePipe } from '../../pipes/store-name.pipe';
import { OrdersBaseComponent } from '@components/admin/managed-board/base/orders-base/orders-base.component';
import { VendorsBaseComponent } from '@components/admin/managed-board/base/vendors-base/vendors-base.component';
import { LogMenuComponent } from '@components/admin/log-menu/log-menu.component';

const SHARED_DECLARATIONS = [
  PatientDialogComponent,
  AutocompletePatientComponent,
  AutocompleteVendorProductsComponent,
  AutocompleteVendorsComponent,
  SaveComponent,
  LogoutComponent,
  DeleteComponent,
  OkCancelComponent,
  UnsavedComponent,
  GalleryComponent,
  ThumbnailDirective,
  NewlinePipe,
  HighlightDirective,
  PhonePipe,
  DisplayInvoicePipe,
  StoreNamePipe,
  ClickFieldDirective,
  OrdersBaseComponent,
  VendorsBaseComponent,
  LogMenuComponent,
];

@NgModule({
  declarations: SHARED_DECLARATIONS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule,
    DateModule,
    Ng2FittextModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    MaterialModule,
    DateModule,
    Ng2FittextModule,
    ...SHARED_DECLARATIONS,
  ],
  entryComponents: [
    SaveComponent,
    DeleteComponent,
    OkCancelComponent,
    LogoutComponent,
    UnsavedComponent,
    GalleryComponent,
    PatientDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminSharedModule {}
